import { Star, BookOpen, Heart, Trophy, Sun, Smile, Zap, Award } from "lucide-react";

export const AVATARS = {
  star:   { icon: Star,     color: "#FFD166", bg: "#FFF9E0" },
  book:   { icon: BookOpen, color: "#118AB2", bg: "#E0F4FF" },
  heart:  { icon: Heart,    color: "#EF476F", bg: "#FFE0EB" },
  trophy: { icon: Trophy,   color: "#F77F00", bg: "#FFE9CC" },
  sun:    { icon: Sun,      color: "#FF9F1C", bg: "#FFF3CD" },
  smile:  { icon: Smile,    color: "#06D6A0", bg: "#E0FFF5" },
  zap:    { icon: Zap,      color: "#9B5DE5", bg: "#F0E6FF" },
  award:  { icon: Award,    color: "#4CC9F0", bg: "#E0F7FF" },
};

export function AvatarDisplay({ avatar, size = 48 }) {
  const av = AVATARS[avatar] || AVATARS.star;
  const Icon = av.icon;
  return (
    <div className="rounded-full flex items-center justify-center flex-shrink-0"
      style={{ width: size, height: size, backgroundColor: av.bg, border: `3px solid ${av.color}` }}>
      <Icon size={size * 0.45} color={av.color} strokeWidth={2.5} />
    </div>
  );
}

export default AvatarDisplay;
